import { HttpResponse } from '@angular/common/http';

import { ApiOptions } from '../../api-options.decorator';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseMidBack } from './base';

/**
 * @internal
 */
export class ApiMidbackVolumes extends ApiBaseMidBack {
  @ApiOptions({ requestType: 'form', responseType: 'blob', responseObserve: 'response' })
  exportGasExcel(params: ParamsAdapter) {
    return this.get<HttpResponse<Blob>>('/volumes/consumption/gas/export/excel', params);
  }
}
